import React from 'react';
import RiddleHistoryToggle from './RiddleHistoryToggle';
import CoinIcon from '../../icons/CoinIcon';
import './RiddlePanel.css';

const RiddlePanel = ({
  isOpen,
  onClose,
  onRevealNormal,
  onRevealEasy,
  riddleText,
  riddles,
  isLoading,
  canAffordNormal,
  normalCost,
  canAffordEasy,
  easyCost,
  freeEasyRiddlesRemaining = 0,
  useCount,
  errorMessage,
}) => {
  if (!isOpen) return null;

  const normalDisabled = isLoading || !canAffordNormal;
  const easyDisabled = isLoading || !canAffordEasy;
  const normalLabel = isLoading
    ? 'Generating...'
    : useCount > 0
      ? 'Generate another riddle'
      : 'Generate riddle';
  const easyLabel = isLoading ? 'Generating...' : 'Generate easy riddle';
  const easyCostLabel = freeEasyRiddlesRemaining > 0 ? `Free: ${freeEasyRiddlesRemaining}` : null;
  const easyCostClass =
    freeEasyRiddlesRemaining > 0 ? 'cost-indicator free' : 'cost-indicator';

  return (
    <div className="riddle-panel" role="region" aria-label="Riddle panel">
      <div className="riddle-panel-header">
        <h3>Riddle</h3>
        <button className="riddle-back-button" type="button" onClick={onClose}>
          Go back
        </button>
      </div>
      <div className="riddle-panel-body">
        {riddleText ? (
          <p className="riddle-text">{riddleText}</p>
        ) : (
          <p className="riddle-placeholder">
            Generate a riddle for the current word.
          </p>
        )}
        {errorMessage && <p className="riddle-error">{errorMessage}</p>}
        <RiddleHistoryToggle riddles={riddles} />
      </div>
      <div className="riddle-panel-actions">
        <button
          className={`riddle-reveal-button ${normalDisabled ? 'disabled' : ''}`}
          type="button"
          onClick={onRevealNormal}
          disabled={normalDisabled}
        >
          <span className="label">{normalLabel}</span>
          <span className="cost-indicator">
            {normalCost}
            <CoinIcon />
          </span>
        </button>
        {!canAffordNormal && (
          <span className="riddle-hint">Not enough coins for the next riddle.</span>
        )}

        <button
          className={`riddle-reveal-button ${easyDisabled ? 'disabled' : ''}`}
          type="button"
          onClick={onRevealEasy}
          disabled={easyDisabled}
        >
          <span className="label">{easyLabel}</span>
          {easyCostLabel ? (
            <span className={easyCostClass}>{easyCostLabel}</span>
          ) : (
            <span className={easyCostClass}>
              {easyCost}
              <CoinIcon />
            </span>
          )}
        </button>
        {!canAffordEasy && (
          <span className="riddle-hint">Not enough coins for an easy riddle.</span>
        )}
      </div>
    </div>
  );
};

export default RiddlePanel;
